export enum TaxRegime {
  GSTIndia = 1,
  VAT = 2,
  SalesTaxUSA = 3,
}

export enum TaxType {
  CGST = 1,
  SGST = 2,
  IGST = 3,
  VAT = 4,
  SalesTax = 5,
}

export enum TaxCalculationMethod {
  Inclusive = 1,
  Exclusive = 2,
}

export enum InvoiceStatus {
  Void = 'void',
  Open = 'open',
  PartialOpen = 'partialopen',
  Closed = 'closed',
}

export enum InvoiceStatusEnum {
  Void = 0,
  Open = 1,
  PartialOpen = 2,
  Closed = 3,
}

export enum PaymentStatus {
  Open = 'open',
  PartiallyOpen = 'partialOpen',
  Closed = 'closed',
  PendingRealization = 'pendingrealization',
  Erroneous = 'Erroneous',
  Void = 'void',
}

export enum PaymentStatusNumerical {
  Open = 1,
  PartiallyOpen = 2,
  Closed = 3,
  PendingRealization = 8,
  Erroneous = 9,
  Void = 6,
  Refunded = 7,
}

export enum PaymentStatusEnum {
  Open = 1,
  PartiallyOpen = 2,
  Closed = 3,
  PendingRealization = 8,
  Erroneous = 9,
  Void = 6,
  Refunded = 7,
}

export enum InvoiceType {
  Service = 1,
  Product = 2,
  Charge = 3,
}

export enum TransactionType {
  Credit = 1,
  Debit = 2,
}

export enum CreditBalanceTypeEnum {
  Payment = 1,
  Invoice = 2,
  CreditBalance = 3,
  OpenCreditBalance = 4,
  PaymentVoid = 5,
  SalesReturn = 6,
  SalesReturnVoid = 7,
  PaymentRefund = 8,
  CreditBalanceRefunded = 9,
}

export enum RecurringAddonsStartMode {
  Today = 1,
  NextCycle = 2,
}
export enum RecurringOccuranceType {
  InitialProRata = 1,
  Recurring = 2,
  Deposit = 3,
  MiddCycleDiscount = 4,
  MiddCycleAddon = 5,
  Freeze = 6,
  EndProrata = 7,
  InitialFullRecurring = 8,
}

export enum PaymentDerivedStatus {
  None = 0,
  Created = 1,
  Initiated = 2,
  Authorized = 3,
  Successfull = 4,
  Failed = 5,
}

export enum LinkType {
  SignUp = 1,
  Product = 2,
  Charge = 3,
  Balance = 4,
  Transfer = 5,
  CreditBalance = 6,
  Refund = 7,
  PaymentMethod = 8,
}

export enum FailedDunningInvoiceOutcome {
  NoPaid = 1,
  Void = 2,
  SalesReturn = 3,
  WriteOff = 5,
}

export enum FailedDunningSubscriptionOutcome {
  Nochange = 1,
  Suspended = 2,
  Cancelled = 3,
}


